export default __webpack_public_path__ + "static/media/book cover - back.98dd05e3.png";